import { render, staticRenderFns } from "./CocoKlockner.vue?vue&type=template&id=b67e2792&"
import script from "./CocoKlockner.vue?vue&type=script&lang=js&"
export * from "./CocoKlockner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports